import styled from 'styled-components';
import Title from 'js/components/core/SteppedPage/Title';

export default styled(Title)`
  max-width: 325px;
  margin: 1rem auto 2rem;
`;
